import { useMatomo } from "@jonkoops/matomo-tracker-react";
import type { FC } from "react";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import { useEnrichedWallet } from "../../../contexts/enrichedWallet";
import { useMarkets } from "../../../contexts/market";

export const DashboardUtils: FC = () => {
  const location = useLocation();
  const { connected } = useEnrichedWallet();
  const { marketsInitialised } = useMarkets();
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: "Dashboard",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToSection = useCallback(
    (key: string) =>
      scroller.scrollTo(key, {
        duration: 750,
        delay: 0,
        smooth: true,
        offset: -10,
      }),
    [],
  );

  useEffect(() => {
    if (connected && marketsInitialised) {
      if (location.hash) {
        scrollToSection(location.hash.substring(1));
      }
    }
  }, [connected, location.hash, marketsInitialised, scrollToSection]);

  return null;
};
